import { useQuery } from "@tanstack/react-query";
import api from "../utils/app";

const fetchPopularMovies = () => {
    return api.get(`/movie/popular?language=ko-KR`);
}

export const usePopularMoviesQuery = () =>{
    return useQuery({
        queryKey:['movie-popular'],
        queryFn: fetchPopularMovies,
        select: (result) => result.data
    })
}